export default __webpack_public_path__ + "static/media/Mark-Regular.v1.a8647ea3.woff2";